export default __webpack_public_path__ + "static/media/app_deezer.b7700d76.svg";